import { Component } from '@angular/core';

@Component({
  selector: 'ai',
  templateUrl: './ai.component.pug',
  styleUrls: [ './ai.component.scss' ],
})
export class AiComponent { }
